var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messageContext)?_c('div',{staticClass:"time"},[_c('div',{staticClass:"content"},[_c('span',{staticClass:"time-item"},[_vm._v(_vm._s(_vm.messageContext.text)+",")]),(_vm.messageContext.link)?_c('span',{staticClass:"link",on:{"click":_vm.onLink}},[_vm._v("去缴费")]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }